export default {
    format(number) {
        if (!number || number.length < 10) {
            return number;
        }
        // strip out all spaces and non-numeric characters
        let nums = number.replace(/\D/g, '');
        // add country code - usa only
        if (nums.length === 11) {
            nums = `+${nums}`;
        } else if (!nums.startsWith('+1')) {
            nums = `+1${nums}`;
        }
        //console.log(`Formatted ${number} as ${nums}`);
        return nums;
    },
};
